import TextField from "@mui/material/TextField";

import "./styles.scss";

const TextInput = ({
  onChange,
  type = "text",
  name,
  label,
  required,
  placeholder,
  disabled,
  value,
  error,
  helperText,
  multiline,
}) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <TextField
      onChange={handleChange}
      type={type}
      error={!!error}
      name={name}
      label={label}
      value={value}
      helperText={error ? error : helperText}
      disabled={disabled}
      placeholder={type === "date" ? "" : placeholder}
      required={required}
      multiline={multiline}
      rows={4}
      autoComplete="new-password"
      InputLabelProps={{
        shrink: type === "date" ? true : undefined,
      }}
    />
  );
};

export default TextInput;
